import {
  Box,
  Container,
  Header,
  SpaceBetween,
  StatusIndicator,
  Link
} from '@amzn/awsui-components-react/polaris';
import Layout from '../layout/Layout';
import { useNavigate } from 'react-router-dom';

interface AgentPlaceholderProps {
  agentName: string;
}

const AgentPlaceholder = ({ agentName }: AgentPlaceholderProps) => {
  const navigate = useNavigate();

  return (
    <Layout>
      <Container
        header={
          <Header
            variant="h1"
            description="This agent is under development"
          >
            {agentName}
          </Header>
        }
      >
        <SpaceBetween direction="vertical" size="l">
          <StatusIndicator type="in-progress">
            Coming Soon
          </StatusIndicator>
          <Box variant="p">
            This agent interface is currently being developed. Check back later for updates.
          </Box>
          <Link
            onFollow={(event) => {
              event.preventDefault();
              navigate('/maps-data-genai-hub');
            }}
            href="/maps-data-genai-hub"
          >
            Back to GenAI Hub
          </Link>
        </SpaceBetween>
      </Container>
    </Layout>
  );
};

export default AgentPlaceholder;
